// Object-fit needs to have percetage between 0 and 100
function clamp(value: number) {
  return Math.min(Math.max(value, 0), 100);
}

// Prismic returns rect as a part of the URL, extract it.
export function extractRectFromUrl(imageUrl: string) {
  const params = new URLSearchParams(imageUrl);
  const rectParams = params.get('rect');

  if (rectParams) {
    return rectParams.split(',').map(Number);
  }

  return null;
}

// Extracts the focus point from the image URL and calculates its object-position
export function extractFocusPoint(
  focusUrl: string,
  original: { width: number; height: number }
) {
  const rectMatch = extractRectFromUrl(focusUrl) || [];

  const [x, y, w, h] = rectMatch.map(Number);

  const focusCenterX = x + w / 2;
  const focusCenterY = y + h / 2;

  const focusXPercent = (focusCenterX / original.width) * 100;
  const focusYPercent = (focusCenterY / original.height) * 100;

  return {
    x: clamp(focusXPercent),
    y: clamp(focusYPercent),
  };
}
